import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import FeatherIcon from 'feather-icons-react';
import moment from 'moment';
import { Link } from 'react-router-dom';

export const tableColumnsForNormalPointsReward: ColumnDef<any>[] = [
  {
    accessorKey: 'points',
    header: 'Points',
    cell: ({ row: { original } }) => {
      const { points } = original;
      return <>{points}</>;
    },
    meta: {
      headerProps: { className: 'pe-3' }
    }
  },
  {
    accessorKey: 'waterAmount',
    header: 'Water Amount',
    meta: {
      headerProps: {},
      cellProps: { className: 'text-body fs-9' }
    }
  },
  {
    accessorKey: 'rewardType',
    header: 'Reward Type',
    cell: ({ row: { original } }) => {
      const { rewardType } = original;
      return <span className="fw-semibold">{rewardType}</span>;
    },
    meta: {
      headerProps: { className: 'pe-3' }
    }
  },
  {
    accessorKey: 'rewardIdentity',
    header: 'Reward Identity',
    cell: ({ row: { original } }) => {
      const { rewardIdentity } = original;
      return <span className="fw-semibold">{rewardIdentity}</span>;
    },
    meta: {
      headerProps: { className: 'pe-3' }
    }
  },
  {
    accessorKey: 'loggedDate',
    header: 'Logged Date',
    cell: ({ row: { original } }) => {
      const { loggedDate } = original;
      return (
        <span className="fw-semibold">
          {moment(loggedDate).format('MM-DD-YYYY h:mm A')}
        </span>
      );
    },
    meta: {
      headerProps: { className: 'pe-3' }
    }
  }
];

const UserNormalPointsRewardTable = () => {
  return (
    <div className="border-y border-translucent">
      <AdvanceTable tableProps={{ className: 'phoenix-table table-sm fs-9' }} />
      <AdvanceTableFooter pagination showViewAllBtn={false} />
    </div>
  );
};

export default UserNormalPointsRewardTable;
